"use strict";

import $ from 'jquery';

let scriptCache = {};

export default function loadScript (url) {
    if (!url.startsWith('http') && !url.startsWith('//')) {
        console.warn('\'loadScript\' should only be used for external resources. Use \'import\' for local files. \n Loaded url was \'' + url + '\'');

        if (process.env.CACHE_BUSTER) {
            url = '/cache-buster-' + process.env.CACHE_BUSTER + url;
        }
    }

    if (!scriptCache[url]) {
        scriptCache[url] = $.ajax({
            url: url,
            dataType: "script",
            cache: true
        });
        scriptCache[url].catch(function (errorMsg) {
            console.error('error loading script ' + url + '\n',  errorMsg);
        });
    }
    return scriptCache[url];
};
